




































































































































import { Vue, Component, Watch, Ref } from 'vue-property-decorator'
import { Produto, ProdutoComVariantes, AtributoDoProduto, AtributosDaVariante, Variante } from '@/models'
import { FindProdutoUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { primaryColor } from '@/plugins/vuetify'

@Component
export default class DialogoDeSelecionarVariante extends Vue {
	@Ref() cards!: {
		$el: HTMLElement
	}[]
	@Ref() revisar!: HTMLLinkElement
	@Ref() campoDeBusca!: { focus: () => void }

	produto: ProdutoComVariantes | null = null
	mostra = false
	indiceAtributoAtual = 0
	valoresSelecionados: string[] = []
	findProdutoUseCase = new FindProdutoUseCase()
	atributosSelecionados: AtributosDaVariante[] = []
	variante: Variante | null = null
	buscando = false
	temVariante = true
	busca = ''
	indiceEmFoco = 0

	async abrir(produto: Promise<DialogoDeSelecionarVariante['produto']>) {
		this.produto = null
		this.valoresSelecionados = []
		this.atributosSelecionados = []
		this.busca = ''
		this.indiceEmFoco = 0
		this.mostra = true
		this.produto = await produto
	}

	fechar() {
		this.mostra = false
	}

	get atributo(): AtributoDoProduto | null {
		return (
			this.produto?.atributosProduto[this.valoresSelecionados.length] ?? null
		)
	}

	get valoresDoAtributo(): string[] {
		const valores = (this.atributo?.valores ?? []).map(valor =>
			typeof valor === 'string' ? valor : (valor as any)?.valor ?? String(valor),
		)
		return [...new Set(valores)]
	}

	get valoresEmExibicao(): string[] {
		const termo = (this.busca || '').trim().toUpperCase()
		if (!termo) return this.valoresDoAtributo
		return this.valoresDoAtributo.filter(valor => valor.toUpperCase().includes(termo))
	}

	get colunasDaGrade(): number {
		return this.$vuetify.breakpoint.xs ? 1 : 4
	}

	get estiloDoValorEmFoco() {
		return {
			outline: `3px solid ${primaryColor()}`,
			outlineOffset: '2px',
		}
	}

	@Watch('atributo')
	onChangeAtributo() {
		this.busca = ''
		this.indiceEmFoco = 0
		setTimeout(() => {
			if (
				this.valoresSelecionados.length ===
					this.produto?.atributosProduto.length &&
				!this.selecionado
			) {
				this.focarRevisar()
			} else {
				this.focarBusca()
			}
		})
	}

	@Watch('busca')
	onChangeBusca() {
		this.indiceEmFoco = 0
	}

	moverFoco(passo: number) {
		const total = this.valoresEmExibicao.length
		if (!total) return

		const destino = this.indiceEmFoco + passo
		if (destino < 0 || destino > total - 1) return

		this.indiceEmFoco = destino
		this.rolarAteOFoco()
	}

	moverFocoParaEsquerda(evento: KeyboardEvent) {
		if (this.cursorNaoEstaNoInicioDoTexto(evento)) return
		evento.preventDefault()
		this.moverFoco(-1)
	}

	moverFocoParaDireita(evento: KeyboardEvent) {
		if (this.cursorNaoEstaNoFimDoTexto(evento)) return
		evento.preventDefault()
		this.moverFoco(1)
	}

	/**
	 * Setas laterais só navegam entre os valores quando não há texto para percorrer,
	 * senão o operador perderia o controle do cursor dentro da pesquisa.
	 */
	cursorNaoEstaNoInicioDoTexto(evento: KeyboardEvent) {
		const campo = evento.target as HTMLInputElement | null
		if (!campo || campo.selectionStart === null) return false
		return campo.selectionStart > 0
	}

	cursorNaoEstaNoFimDoTexto(evento: KeyboardEvent) {
		const campo = evento.target as HTMLInputElement | null
		if (!campo || campo.selectionEnd === null) return false
		return campo.selectionEnd < (campo.value || '').length
	}

	selecionarValorEmFoco() {
		if (!this.atributo) return

		const valor = this.valoresEmExibicao[this.indiceEmFoco]
		if (valor === undefined) return

		this.selecionarValor(valor, this.atributo.atributo.nome)
	}

	rolarAteOFoco() {
		this.$nextTick(() => {
			const card = this.cards && this.cards[this.indiceEmFoco]
			if (!card) return
			card.$el.scrollIntoView({ block: 'nearest' })
		})
	}

	get items() {
		return (
			this.produto?.atributosProduto.map((atributo, indice) => {
				const valor: string | undefined = this.valoresSelecionados[indice]

				return {
					id: atributo.id,
					disabled: indice > this.valoresSelecionados.length,
					text: valor
						? `${atributo.atributo.nome}: ${this.valoresSelecionados[indice]}`
						: `${atributo.atributo.nome}`,
				}
			}) ?? []
		)
	}

	obterIndiceDoAtributo(atributo: AtributoDoProduto) {
		return (
			this.produto?.atributosProduto.findIndex(
				({ id }) => atributo.id === id,
			) ?? -1
		)
	}

	resetarPara(atributo: AtributoDoProduto) {
		const indice = this.obterIndiceDoAtributo(atributo)
		if (indice <= -1) return
		this.valoresSelecionados.splice(indice)
		this.atributosSelecionados.splice(indice)
	}

	get selecionado () {
		const produto = this.produto
		if (
			!produto ||
			this.valoresSelecionados.length !== produto.atributosProduto.length
		)
			return null

		return this.variante
	}

	async selecionarValor(valor: string, nome: string) {
		this.valoresSelecionados.push(valor)
		this.atributosSelecionados.push({
			id: null,
			nome: nome,
			valor: valor,
			descontoVarejo: 0,
		})

		if (this.valoresSelecionados.length ===
					this.produto?.atributosProduto.length) {
			try {
				this.buscando = true
				const variante = await this.findProdutoUseCase.buscarVariantePorAtributos(this.produto.id, this.atributosSelecionados)
				await this.findProdutoUseCase.validarProdutoDesativado(variante.id)
				this.variante = variante
				if (!this.variante) this.temVariante = false
			} catch (error: any) {
				AlertModule.setError(error)
				this.mostra = false
			} finally {
				this.buscando = false
			}
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) {
			this.$emit('cancel')
		}
	}

	@Watch('selecionado')
	onChangeSelecionado(produtoSelecionado: Produto | null) {
		if (!produtoSelecionado) return

		this.$emit('input', produtoSelecionado)
		this.mostra = false
		this.variante = null
	}

	focarBusca() {
		if (!this.campoDeBusca) return
		this.campoDeBusca.focus()
	}

	focarRevisar() {
		if (!this.revisar) return
		this.revisar.focus()
	}

	quantidadeEmEstoque(valorAtributo: string, tipoAtributo: string) {
		if (!this.produto?.estoquesPorVariacao) return 0;

		const tipo = tipoAtributo.toUpperCase();

		const atributosMapeados = (this.atributosSelecionados || []).reduce((map, attr) => {
			map[attr.nome.toUpperCase()] = attr.valor;
			return map;
		}, {} as Record<string, string>);

		atributosMapeados[tipo] = valorAtributo;

		const estoques = this.produto.estoquesPorVariacao;

		const estoquesFiltrados = estoques.filter(estoque => {
			const tamanho = atributosMapeados['TAMANHO'] ? estoque.tamanho === atributosMapeados['TAMANHO'] : true;
			const cor = atributosMapeados['COR'] ? estoque.cor === atributosMapeados['COR'] : true;
			return tamanho && cor;
		});

		return estoquesFiltrados.reduce((total, e) => total + (e.estoqueDisponivel ?? 0), 0);
	}
}
